import { PureComponent } from "react";

export default class CustomizedAxisTick extends PureComponent {
  render() {
    // eslint-disable-next-line react/no-this-in-sfc,react/prop-types
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={10}
          dx={15}
          textAnchor="end"
          fill="#666"
          stroke={stroke}
          transform="rotate(-15)"
        >
          {/* eslint-disable-next-line react/prop-types */}
          {payload.value}
        </text>
      </g>
    );
  }
}
